import React, { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';
import classNames from 'classnames';

import { Icon, Tappable } from '@vectord/components';
import {
  setAddMenteeModuleModalState,
  setSelectedMenteeModule,
} from 'features/moduleManagement';
import styles from './AddMenteeModuleButton.module.scss';

function AddMenteeModuleButton({ menteeModule }: IAddMenteeModuleModalButton) {
  const dispatch = useDispatch();

  const handleOnClick = useCallback(() => {
    batch(() => {
      dispatch(setAddMenteeModuleModalState(true));
      dispatch(setSelectedMenteeModule({ ...menteeModule }));
    });
  }, [dispatch, menteeModule]);
  return (
    <Tappable
      onClick={handleOnClick}
      className={classNames('btn btn-outlined btn-primary m-r-10', styles.root)}
    >
      <Icon
        name="add"
        className="m-r-5"
      />
      Add Module Below
    </Tappable>
  );
}

export default AddMenteeModuleButton;
